<div id="markers">

  @if (rnaMarkers().length !== 0) {
    <div class="marker-container">
      <div class="row">
        <div class="label-container">RNA Marker</div>
        <div class="composition-container">
          @for (marker of rnaMarkers(); track marker.dbId) {
            <cr-object-tree
              [type]=" DataKeys.RNA_MARKERS"
              [data]="[marker]"></cr-object-tree>

            @let literatureRefs = refs().get(marker.dbId);
            @if (literatureRefs) {
              <cr-refs-tree [referenceHolder]="literatureRefs"></cr-refs-tree>
            }
          }
        </div>
      </div>
    </div>
  }

  @if (proteinMarkers().length !== 0) {
    <div class="marker-container">
      <div class="row">
        <div class="label-container">Protein Marker</div>
        <div class="composition-container">
          @for (marker of proteinMarkers(); track marker.dbId) {
            <cr-object-tree
              [type]="DataKeys.PROTEIN_MARKER"
              [data]="[marker]"></cr-object-tree>

            @let literatureRefs = refs().get(marker.dbId);
            @if (literatureRefs) {
              <cr-refs-tree [referenceHolder]="literatureRefs"></cr-refs-tree>
            }
          }
        </div>
      </div>
    </div>
  }

</div>
